export default "__VITE_ASSET__BKU9uIIl__"